import { useState } from 'react';
import { T, useGT } from 'gt-react';
import { workbookExportFileNameSchema } from '@erp/shared-types';
import { Input } from '@/components/ui/input';

export function WorkbookExportName({
  name,
  disabled,
  change,
}: {
  name: string;
  disabled: boolean;
  change: (name: string) => void;
}) {
  const gt = useGT();
  const [draft, setDraft] = useState(name);
  const [error, setError] = useState(false);
  function save() {
    const value = draft.trim();
    const parsed = workbookExportFileNameSchema.safeParse(
      /\.xlsx$/i.test(value) ? value : `${value}.xlsx`,
    );
    setError(!parsed.success);
    if (parsed.success) {
      setDraft(parsed.data);
      if (parsed.data !== name) change(parsed.data);
    }
  }
  return (
    <div className="space-y-1">
      <label className="flex items-center gap-2 whitespace-nowrap text-xs">
        <T context="workbook export filename">File name</T>
        <Input
          className="h-8 max-w-64"
          value={draft}
          disabled={disabled}
          aria-invalid={error}
          onChange={(event) => setDraft(event.target.value)}
          onBlur={save}
          onKeyDown={(event) => {
            if (event.key === 'Enter') save();
          }}
          placeholder={gt('export.xlsx', {
            context: 'workbook export filename placeholder',
          })}
        />
      </label>
      {error && (
        <p role="alert" className="text-xs text-destructive">
          <T context="workbook invalid export filename">
            Enter a filename without path separators or special characters.
          </T>
        </p>
      )}
    </div>
  );
}
